import styled from "styled-components"

export const Section = styled.section`
  padding: 24px;
  border-radius: 20px;
  background: var(--surface-2);
`

export const SectionTitle = styled.h2`
  margin: 0 0 20px;
  font-size: 20px;
  font-weight: 600;
  color: var(--text-primary);
`

export const CardsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`

export const Card = styled.div`
  flex: 1 0 0;
  min-width: min(360px, 100%);
  padding: 24px 32px;
  border-radius: 20px;
  border: 1px solid var(--border-default);
  background: var(--surface-1);
`

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
`

export const CardTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.176px;
  color: #0f172a;
`
